<template>
  <section id="header" class="header">
    <div class="l-center">
      <nav class="nav ff--trajanpro-bold">
        <ul>
          <li v-gtag:nav="$locale.header.join" class="nav-item">
            <a href="#join">{{ $locale.header.join }}</a>
          </li>
          <li v-gtag:nav="$locale.header.kol" class="nav-item">
            <a href="#kol">{{ $locale.header.kol }}</a>
          </li>
          <li
            v-gtag:nav="$locale.header.rank"
            class="nav-item"
            v-if="isLogin && isJoinCivi"
          >
            <a href="#rank">{{ $locale.header.rank }}</a>
          </li>
          <li v-gtag:nav="$locale.header.data" class="nav-item">
            <a href="#list">{{ $locale.header.data }}</a>
          </li>
          <li v-gtag:nav="$locale.header.rewards" class="nav-item">
            <a href="#rewards">{{ $locale.header.rewards }}</a>
          </li>
          <li v-gtag:nav="$locale.header.follow" class="nav-item">
            <a href="#follow">{{ $locale.header.follow }}</a>
          </li>
        </ul>
      </nav>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Header",
  data() {
    return {};
  },
  created() {},
  mounted() {
    $("#header .nav-item a").on("click", function (ev) {
      ev.preventDefault();
      $("html").animate(
        {
          scrollTop:
            $($(this).attr("href")).get(0).offsetTop - $("#header").height(),
        },
        300
      );
    });
  },
  watch: {},
  computed: {
    ...mapGetters(["isLogin", "isJoinCivi", "userInfo"]),
  },
  methods: {},
};
</script>

<style lang="less">
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: var(--header-height);
  background: url("~images/header/bg.jpg") no-repeat;
  background-position: 0 0;
  background-size: 100% 100%;
  z-index: 99;

  .l-center {
    display: flex;
    width: 100%;
    height: 100%;
  }

  .nav {
    flex: 1;

    ul {
      display: flex;
      height: 100%;
    }

    &-item {
      position: relative;
      flex: 1;
      transition: 1s;
      background: transparent;

      &:not(:last-child)::after {
        position: absolute;
        right: -5px;
        top: 0;
        content: "";
        width: 10px;
        height: 100%;
        background: url(~images/header/border.png) no-repeat 0 center;
        background-size: 100% auto;
      }

      a {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        padding: 0 10px;
        text-align: center;
        font-size: 22px;
        color: var(--primary-color);
        text-shadow: 1px 2px 0px rgba(57, 46, 32, 0.54),
          0px 0px 1px rgba(255, 233, 129, 0.69);
      }

      &:hover {
        background: url(~images/header/active.jpg) no-repeat 0 0;
        background-size: 100% 100%;
      }
    }
  }
}
</style>
